const extractSlugFromUrl = (url: string): string => {
    const matches = url.match(
        new RegExp('/v[0-9]*/de/cms/[a-z/]*tag/.*?(?=(/platform|/layoutMode|$))')
    )
    return matches && matches.length ? matches[0] : url
}

export default extractSlugFromUrl
